module.exports = __webpack_public_path__ + "img/sq_record_img.957b3fed.png";